import { render, staticRenderFns } from "./AllocationGroupwiseTare.vue?vue&type=template&id=abcc1c9a&scoped=true"
import script from "./AllocationGroupwiseTare.vue?vue&type=script&lang=js"
export * from "./AllocationGroupwiseTare.vue?vue&type=script&lang=js"
import style0 from "./AllocationGroupwiseTare.vue?vue&type=style&index=0&id=abcc1c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcc1c9a",
  null
  
)

export default component.exports